import React, { useState } from 'react';
import { useEditorStore } from '../store/editorStore';
import { File, Plus, Trash2 } from 'lucide-react';

const FileTree: React.FC = () => {
  const { project, setActiveFile, createFile, deleteFile } = useEditorStore();
  const [newFileName, setNewFileName] = useState('');

  const handleCreateFile = () => {
    if (!newFileName.trim()) return;

    const language = newFileName.endsWith('.html')
      ? 'html'
      : newFileName.endsWith('.css')
      ? 'css'
      : newFileName.endsWith('.ts')
      ? 'typescript'
      : newFileName.endsWith('.js')
      ? 'javascript'
      : 'javascript';

    const fileId = createFile(newFileName, language as any);
    setActiveFile(fileId);
    setNewFileName('');
  };

  const renderFileTree = (files: Record<string, any>) => {
    return Object.values(files).map((file: any) => (
      <div key={file.id} className="select-none">
        <div
          className={`flex items-center px-2 py-1 hover:bg-editor-bg cursor-pointer ${
            useEditorStore.getState().activeFileId === file.id ? 'bg-editor-bg' : ''
          }`}
          onClick={() => setActiveFile(file.id)}
        >
          <div className="flex items-center flex-1">
            <File size={16} className="mr-2 text-gray-400" />
            <span className="text-sm text-gray-300">{file.name}</span>
          </div>
          <button
            className="opacity-0 group-hover:opacity-100 hover:bg-red-600 rounded p-1 transition-opacity"
            onClick={(e) => {
              e.stopPropagation();
              if (confirm(`确定要删除 ${file.name} 吗？`)) {
                deleteFile(file.id);
              }
            }}
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div className="h-full bg-editor-panel border-r border-editor-border flex flex-col">
      <div className="p-3 border-b border-editor-border">
        <h3 className="text-sm font-semibold text-gray-300 mb-2">文件</h3>
        <div className="flex">
          <input
            type="text"
            value={newFileName}
            onChange={(e) => setNewFileName(e.target.value)}
            placeholder="新文件名..."
            className="flex-1 px-2 py-1 text-sm bg-editor-bg border border-editor-border rounded-l text-gray-300 focus:outline-none focus:border-blue-500"
            onKeyPress={(e) => e.key === 'Enter' && handleCreateFile()}
          />
          <button
            onClick={handleCreateFile}
            className="px-2 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-r transition-colors"
          >
            <Plus size={16} />
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto">
        {renderFileTree(project.files)}
      </div>
    </div>
  );
};

export default FileTree;
